import { Row, Input, Button, Form, Modal, message, DatePickerProps } from 'antd';
import { useState } from "react";
import { useHistory, useLocation } from "react-router";
import axios from "axios";
import { DatePicker } from 'antd';
import logoLogin from "../../../../../assets/images/kyc/logo-login.png";
import iconNext from "../../../../../assets/images/icon/next-arrow.svg";
import environment from "../../../../../config/environment";
import { i18n } from '../../../../../i18n/i18n';
import { useTranslation } from "react-i18next";
import { namespaces } from "../../../../../i18n/i18n.constants";
import alert from "../../../../../assets/images/kyc/alert.png";
import done from "../../../../../assets/images/kyc/done.png";
import { CalendarFilled } from "@ant-design/icons";
// import "./index.css";

const LoginDateClassifyPage = () => {
  const [dataDate, setDataDate] = useState<string>('');
  const history = useHistory();
  const location: any = useLocation();
  const { t } = useTranslation(namespaces.pages.daolSecClassify);
  const [isLoading, setLoading] = useState(false);

  const onChangeDate: DatePickerProps['onChange'] = (date: any, dateString) => {
    // console.log("DatePicker", dateString);
    // console.log("DatePicker date", date.format("YYYYMMDD"));
    // console.log("DatePicker Moment", dateString.format("YYYYMMDD"));
    setDataDate(date.format("YYYYMMDD"));
  };

  const onSubmitLogin = (e: React.FormEvent<HTMLFormElement>) => {
    setLoading(true);
    // console.log("customer", location?.state?.customerId);
    axios.get(`${environment?.baseApi}/getKycDateCustomer?customerId=${location?.state?.customerId}&birthday=${dataDate}`)
      .then(res => {
        // console.log('resCustomer', res)
        if (res.status === 500) {
          setLoading(false);
          Modal.error({
            icon: <img src={alert} className="img-popup" alt="alert" />,
            title: t("popup_error500_title"),
            content: (<>`<div>{t("popup_error500_content")}</div>`</>),
            okText: t("btn_again"),
            onOk() { },
          });
        }
        if (res.status === 200) {
          if (res.data === 'Invalid Data') {
            Modal.error({
              icon: <img src={alert} className="img-popup" alt="alert" />,
              title: t("popup_login_error_title"),
              content: t("popup_login_date_error_content"),
              okText: t("btn_again"),
              onOk() { },
            });
            setLoading(false);
          } else {
            Modal.error({
              icon: <img src={done} className="img-popup" alt="done" />,
              title: t("success"),
              okText: t("btn_ok"),
              onOk() {
                window.location.href = `${environment?.ekycApi}${res.data}&lang=EN`;
              },
            });
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <>
      {console.log('t', useTranslation(namespaces.pages.daolSecKyc))}
      <div className="home-page mainkyc-page">
        {isLoading === true ?
          <div className="sping-loading">
            <div className="loading"></div>
            <p>{t("loading")}</p>
          </div> : ""}

        <div className="container">
          {/* {console.log('i18n.language', i18n.language)} */}
          <Row className="container-main daol-kyc">
            <div className="content-right col-sm-8 text-center">
              <p><img src={logoLogin} alt="Login" /></p>

              <Form name="normal_login" className="loginKyc-form" initialValues={{ remember: true }} onFinish={onSubmitLogin}>
                <div className="container-from">
                  <Form.Item name="date" label={t("login_text_date_descrip")} className="from-input">
                    {/* <Input placeholder={t("login_cardId_placeholder")} onChange={onChangeCardId} className="input-info" /> */}
                    <DatePicker onChange={onChangeDate} format="DD/MM/YYYY" className="date-picker" suffixIcon={<CalendarFilled />} />
                  </Form.Item>
                </div>
                <Form.Item className="container-button btn-kyc">
                  <Button type="primary" disabled={dataDate === '' ? true : false} htmlType="submit" className="btn-next">
                    {t("btn_next")}
                    <img src={iconNext} alt="icon-next" />
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </Row>
        </div>
      </div>

    </>
  );
};
export default LoginDateClassifyPage;
